import { Button, Icon, Intent, TextArea } from '@blueprintjs/core';
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import cls from './ReportItem.module.css';

class CommentContext extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    data: PropTypes.object,
    disabled: PropTypes.bool,
    onCommentUpdate: PropTypes.func,
  };

  state = {
    commentText: undefined,
  };

  componentDidMount() {
    const { data } = this.props;
    const { payload } = data;

    this.setState({
      commentText: payload?.commentText,
    });
  }

  onChange = event => {
    this.setState({
      commentText: event.target.value,
    });
  };

  onClear = () => {
    this.setState(
      {
        commentText: '',
      },
      this.onConfirm
    );
  };

  onConfirm = () => {
    const { data } = this.props;
    const { payload } = data;
    const { commentText } = this.state;

    if (commentText !== payload.commentText) {
      this.props.onCommentUpdate(data.id, commentText);
    }
  };

  render() {
    const { className, disabled } = this.props;
    const { commentText } = this.state;

    return (
      <div
        className={cx(
          cls.commentContext,
          { [cls.commentContextEmpty]: !commentText },
          { [cls.commentContextEditable]: !disabled },
          className
        )}
      >
        <Icon className={cls.commentIcon} icon="comment" />

        <div data-test="item-comment-section">
          <form className={cls.commentForm}>
            <TextArea
              fill
              growVertically
              disabled={disabled}
              value={commentText || ''}
              placeholder="Add comment..."
              onBlur={this.onConfirm}
              onChange={this.onChange}
            />
            <Button
              className={cls.commentClearButton}
              minimal
              intent={Intent.WARNING}
              text="Clear comment"
              icon="eraser"
              onClick={this.onClear}
              data-test="clear-item-comment-button"
            />
          </form>

          <span className={cls.commentText}>{commentText || 'Empty comment'}</span>
        </div>
      </div>
    );
  }
}

export default CommentContext;
